import React from 'react';
import { translate } from 'translations/i18n';
import Modal from 'react-modal';

import EmptyState from './EmptyState';
import InstallationInstructions from './InstallationInstructions';
import { ActionLink } from 'components/shared';

type SetupGuideModalProps = {
  onRequestClose: () => void;
  showcasePublicIdentifier?: string;
};

const SetupGuideModal = ({
  onRequestClose,
  showcasePublicIdentifier,
}: SetupGuideModalProps) => {
  return (
    <Modal
      ariaHideApp={false}
      contentLabel="View Setup Guide"
      isOpen
      onRequestClose={onRequestClose}
      overlayClassName="modal"
      className="modal-content-wrap modal--wide modal-scroll"
    >
      <ActionLink className="modal-close-button" onClick={onRequestClose}>
        <i
          className="mdi mdi-close"
          data-testid="showcases__modal-close-button"
        />
      </ActionLink>
      <h3 className="modal-title">
        {translate('showcases.setupGuide.heading')}
      </h3>
      {!showcasePublicIdentifier ? (
        <EmptyState />
      ) : (
        <InstallationInstructions
          showcasePublicIdentifier={showcasePublicIdentifier}
        />
      )}
    </Modal>
  );
};

export default SetupGuideModal;
